import api from './api';

// Callbacks told that the unread count may have changed. The bell and the
// notifications page are separate trees, so a write on the page reaches the
// bell through here. Listeners get no count: they refetch it, keeping the
// server the single source of truth.
const listeners = new Set();

function notifyChanged() {
    listeners.forEach((listener) => {
        try {
            listener();
        } catch (_error) {
            // A failing listener must not fail a write that succeeded; the
            // bell corrects itself on its next refetch.
        }
    });
}

export const notificationService = {
    // Returns the unsubscribe function, for use as an effect cleanup.
    subscribe(listener) {
        listeners.add(listener);
        return () => {
            listeners.delete(listener);
        };
    },

    async getMyNotifications(params = {}) {
        const response = await api.get('/notification/mine', { params });
        return response.data;
    },

    async getUnreadCount() {
        const response = await api.get('/notification/unread-count');
        return response.data;
    },

    async markAsRead(notificationId) {
        const response = await api.put(`/notification/${notificationId}/read`);
        notifyChanged();
        return response.data;
    },

    async markAllAsRead() {
        const response = await api.put('/notification/read-all');
        notifyChanged();
        return response.data;
    },

    async deleteNotification(notificationId) {
        const response = await api.delete(`/notification/${notificationId}`);
        notifyChanged();
        return response.data;
    },

    async createNotification(data) {
        const response = await api.post('/notification', data);
        return response.data;
    },
};

export default notificationService;
